import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
const FormError = ({ errorMessage }) => {
  return errorMessage ? (
    <div className="text-danger mt-1">{errorMessage}</div>
  ) : null;
};


const AddVideosModal = ({ show, onClose, onSubmit, onSuccess, video }) => {
  const { t } = useTranslation();
  const [videos, setVideos] = useState({ items: [], total: 0 });

  const [formData, setFormData] = useState({
    englishTitle: "",
    arabicTitle: "",
    englishDescription: "",
    arabicDescription: "",
    link: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === "file") {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
    setErrors((prev) => ({ ...prev, [name]: null }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
  
   setErrors({});

  
    try {
      await onSubmit(formData);
      setErrors({});
      onSuccess?.();
  
      setTimeout(() => {
        onClose();
      }, 3000);
  
      setFormData({
        englishTitle: "",
        arabicTitle: "",
        englishDescription: "",
        arabicDescription: "",
        link: "",
      });
    } catch (error) {
      const responseData = error?.response?.data;
      if (responseData?.message) {
        toast.error(responseData.message);
      } else {
        toast.error(t("something_went_wrong"));
      }
      if (responseData?.errors) {
        setErrors(responseData.errors);
      }
    }
  };
  

  useEffect(() => {
    console.log(video);  
    if (video) {
      setFormData({
        englishTitle: video.englishTitle || "",
        arabicTitle: video.arabicTitle || "",
        englishDescription: video.englishDescription || "",
        arabicDescription: video.arabicDescription || "",
        link: video.link || "",
      });
    }
  }, [video]);
  
  return (
    <div>
      <Modal show={show} onHide={onClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("add_new_video")}</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleFormSubmit}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>{t("video_title_ar")}</Form.Label>
              <Form.Control
                type="text"
                name="arabicTitle"
                value={formData.arabicTitle}
                onChange={handleChange}
                // isInvalid={!!errors.arabicTitle}
              />
              {/* <FormError errorMessage={errors.arabicTitle} /> */}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>{t("video_title_en")}</Form.Label>
              <Form.Control
                type="text"
                name="englishTitle"
                value={formData.englishTitle}
                onChange={handleChange}
                // isInvalid={!!errors.englishTitle}
              />
              {/* <FormError errorMessage={errors.englishTitle} /> */}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>{t("Video_url")}</Form.Label>
              <Form.Control
                type="url"
                name="link"
                value={formData.link}
                onChange={handleChange}
                // isInvalid={!!errors.link}
                placeholder="https://www.youtube.com/watch?v=..."
              />
              <small className="form-text text-muted">
                YouTube, Vimeo أو أي منصة أخرى مدعومة
              </small>
              {/* <FormError errorMessage={errors.link} /> */}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>{t("video_about_ar")}</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="arabicDescription"
                value={formData.arabicDescription}
                onChange={handleChange}
                // isInvalid={!!errors.arabicDescription}
              />
              {/* <FormError errorMessage={errors.arabicDescription} /> */}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>{t("video_about_en")}</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="englishDescription"
                value={formData.englishDescription}
                onChange={handleChange}
                // isInvalid={!!errors.englishDescription}
              />
              {/* <FormError errorMessage={errors.englishDescription} /> */}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-secondary" onClick={onClose}>
              {t("cancel")}
            </Button>
            <Button type="submit" className="btn btn-primary-custom">
              {t("save_changes")}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <ToastContainer />
    </div>
  );
};

export default AddVideosModal;
